import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    '@media screen and (max-width: 700px)': {
      root: {
        maxWidth: 280,
      },
    },

    root: {
      position: 'relative',
      display: 'flex',
      borderRadius: theme.shape.borderRadius,
      background: 'white',
      border: '1px solid',
      borderColor: COLORS.gray.gray70,
      boxShadow: 'none',
      cursor: 'pointer',
      overflow: 'hidden',

      padding: theme.spacing(1.5),
      flexFlow: 'row nowrap',
      alignItems: 'center',
      minHeight: 0,
      height: 'fit-content',
      width: '100%',

      '&:not($disabled):hover': {
        borderColor: COLORS.primary.light,
        boxShadow: '0px 1px 27px rgba(31, 44, 75, 0.1)',
      },

      '&$selected': {
        borderColor: COLORS.primary.default,
      },

      '&$disabled': {
        cursor: 'auto',
      },
    },
    selected: {},
    disabled: {},
    content: {
      width: '100%',
      height: 110,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: theme.spacing(0, 0, 0, 1.5),
      minWidth: 0,
    },

    copyWrapper: {
      height: 'auto',
      paddingTop: theme.spacing(1),
      maxHeight: 74,
    },
    title: {
      width: 'calc(100%)',
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.gray.black,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      marginBottom: theme.spacing(0.5),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },

    description: {
      width: 'calc(100%)',
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: '3',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    icon: {
      width: 116,
      height: 110,
    },

    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 22,
    },

    tagHidden: {
      height: 22,
      visibility: 'hidden',
    },

    toolIconsWrapper: {
      display: 'flex',
      alignItems: 'center',
    },

    toolIcon: {
      width: 36,
      height: 36,
      padding: theme.typography.pxToRem(6),
      backgroundColor: COLORS.gray.gray90,
      borderRadius: '100%',
      border: '2px solid white',
      marginRight: theme.spacing(-0.75),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    moreTools: {
      width: 36,
      height: 36,
      fontSize: theme.typography.pxToRem(16),
      backgroundColor: COLORS.gray.gray90,
      borderRadius: '100%',
      border: '2px solid white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: -4,
    },
  }),
  { name: 'CardCondensed' }
);
